import { defineComponent, ref, onMounted } from "vue";
import { useForm } from "@/views/login/index";
import { TipoComercioService } from "@/services/TipoComercioService";
import { EstadoService } from "@/services/EstadoService";
import VueRecaptcha from "@/components/VueRecaptcha.vue";
import Header from "@/components/Header.vue";
export default defineComponent({
    name: "RegistroYLogin",
    components: {
        VueRecaptcha,
        Header,
    },
    setup() {
        const { isActive, currentStep, progress, form, nextStep, previousStep, handleSubmit, handleLogin, showSignIn, showSignUp, handleRecaptchaInputLogin, handleRecaptchaInputRegister, recaptchaVerifiedLogin, recaptchaVerifiedRegister, showVerificationInput, isRequestingCode, isPhoneVerified, verificationCode, timeLeft, requestVerificationCode, verifyCode, resetPhoneNumber, } = useForm();
        const tiposComercio = ref([]);
        const estados = ref([]);
        const siteKey = "6LfYC64pAAAAAFGFlo3jUOx6RAgwKNtd8gqSg1BE";
        const recaptchaKey = ref("");
        onMounted(async () => {
            try {
                tiposComercio.value = await TipoComercioService.getAllTipoComercios();
                estados.value = await EstadoService.getAllCiudades();
                if (!Array.isArray(estados.value)) {
                    console.error("ciudades no es un array");
                    estados.value = [];
                }
            }
            catch (error) {
                console.error("Error fetching data:", error);
            }
        });
        return {
            isActive,
            currentStep,
            progress,
            form,
            nextStep,
            previousStep,
            handleSubmit,
            handleLogin,
            showSignIn,
            showSignUp,
            tiposComercio,
            estados,
            handleRecaptchaInputLogin,
            handleRecaptchaInputRegister,
            recaptchaVerifiedLogin,
            recaptchaVerifiedRegister,
            showVerificationInput,
            isRequestingCode,
            isPhoneVerified,
            verificationCode,
            timeLeft,
            requestVerificationCode,
            verifyCode,
            resetPhoneNumber,
        };
    },
});
